import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { authLoading, isAuthenticated, isAdmin, isTrialExpired } = useAuth();
  const location = useLocation();

  // OK to keep a spinner here because this is ONLY used for protected routes.
  if (authLoading) {
    return (
      <div className="min-h-screen bg-charcoal-dark flex items-center justify-center">
        <Loader2 className="w-12 h-12 text-aqua animate-spin" />
      </div>
    );
  }

  // Admin shell is separate, so unauthenticated users go to login here.
  if (!isAuthenticated) {
    return <Navigate to={`/login?returnTo=${encodeURIComponent(`${location.pathname}${location.search}`)}`} replace />;
  }

  // Authed but not admin: keep them inside the admin login flow.
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  // Trial expired overlay (unlikely here, but we keep a simple fallback).
  if (isTrialExpired) {
    return (
      <div className="min-h-screen bg-charcoal-dark flex items-center justify-center p-4">
        <div className="bg-charcoal-light rounded-2xl p-8 max-w-md text-center border border-charcoal-lighter">
          <div className="w-16 h-16 rounded-full bg-yellow-500/10 flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">⏰</span>
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Trial Ended</h2>
          <p className="text-gray-400 mb-6">Your session is no longer active. Please sign in again.</p>
          <Navigate to="/login" replace />
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
